import useUserStore from '@/stores/user'
// 处理跳转到其他系统
export const getPublicParms = (obj: Record<string, any> = {}): Record<string, any> => {
    const userStore = useUserStore()
    const { token, tenantCode, tenantId } = userStore
    return {
        AUTHORIZATION: token,
        "TENANT-ID": tenantId,
        "TENANT-CODE": tenantCode,
        "SOURCE-HOST": window.location.href.split('?')[0],
        ...obj
    }
}